import { Component } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TranslateHelperService } from '../../services/TranslateService';
import { AppState } from 'src/app/services/app.service';
import { User } from 'src/app/models/user';

@Component({
    selector: 'self-ins-coverage',
    templateUrl: './coverage-page.component.html',
    styleUrls: ['./coverage-page.component.scss'],
    standalone: false
})
export class CoveragePageComponent{
    public qnum = 0;
    public qsuffix = '';
    public user!: User;

    public constructor(private activeRouter: ActivatedRoute,
        private router: Router,
        public _translateService: TranslateHelperService,
        private appState: AppState) { 
            this.user = this.appState.user.getValue();
        }

    public gotoPage(pageUrl: string) {
        this.router.navigate([`/${pageUrl}`], {
            queryParams: {
                qnum: this.qnum,
                qsuffix: this.qsuffix
            }
        });
    }

    ngOnInit(): void {
        this.activeRouter.queryParams.subscribe(params => {
            this.qnum = params['qnum'];
            this.qsuffix = params['qsuffix'];
          });
    }
}
